import { Head } from "@/components/base/Head";
import React from "react";
import { LpLayout } from "@/layouts/header-footer-none";
import Image from "next/image";
import Link from "next/link";
import { ArrowRightIcon } from "@heroicons/react/24/solid";

const JobTypesPage = () => {
  const META_TITLE = "仕事タイプ動物診断";

  const banners = [
    { image: "top_enfj.jpg" },
    { image: "top_enfp.jpg" },
    { image: "top_entj.jpg" },
    { image: "top_entp.jpg" },
    { image: "top_esfj.jpg" },
    { image: "top_esfp.jpg" },
    { image: "top_estj.jpg" },
    { image: "top_estp.jpg" },
    { image: "top_infj.jpg" },
    { image: "top_infp.jpg" },
    { image: "top_intj.jpg" },
    { image: "top_intp.jpg" },
    { image: "top_isfj.jpg" },
    { image: "top_isfp.jpg" },
    { image: "top_istj.jpg" },
    { image: "top_istp.jpg" },
  ];

  return (
    <>
      <Head
        title={META_TITLE}
        image={"https://app.s-d-lab.jp/images/animal_diagnosis/ogp.jpg"}
        canonicalPath={`/animal_diagnosis`}
      />
      <main className={"bg-[#FBE9E9] pb-20"}>
        <div className={"mb-10 max-w-[1440px] m-auto px-4 py-2"}></div>
        <div className={"max-w-[1200px] bg-white m-auto p-10 rounded-2xl"}>
          <h1 className={"text-center mb-8"}>
            <Image
              width={280}
              height={76}
              src={"/images/animal_diagnosis/title.png"}
              alt={"動物診断"}
              loading={"eager"}
              className={"mx-auto"}
            />
          </h1>
          <div className={"mb-8"}>
            <p className={"text-md leading-[1.75] mb-1"}>
              あなたは自分のことをどれくらい知っていますか？
              <br />
              「自分はこういう性格だ」
              <br />
              「こういうことが得意で、こういうことが苦手」
              <br />
              という主観的な判断は、もしかしたらあなたの個性を知らずの間に潰しているかもしれません。
              <br />
              <br />
              動物タイプ診断は、質問項目を通じて「あなたの本当の性格や価値観」が面白いほど分かるコンテンツです。
              <br />
              普段からあなたが意識している「自分」と、動物タイプ診断で導き出された「自分」を比較することで、あなたの本当の強みをぜひ見つけてみてください。
            </p>
          </div>
          <div className={"bg-white text-center p-4 mb-12"}>
            <h2 className={"text-xl font-bold mb-4"}>あなたはどのタイプ？</h2>
            <div className={"md:grid grid-cols-4 gap-3 m-auto"}>
              {banners.map((banner, index) => (
                <Banner key={index} image={banner.image} />
              ))}
            </div>
          </div>
          <Link
            href={`/animal_diagnosis/diagnosis`}
            className={
              "text-white flex items-center justify-between bg-[#e9536c] md:text-xl w-[150px] md:w-[180px] py-4 px-6 m-auto font-bold rounded-full hover:opacity-70 duration-500"
            }
          >
            診断開始
            <ArrowRightIcon className={"w-5"} />
          </Link>
        </div>
      </main>
    </>
  );
};

const Banner = ({ image }: { image: string }) => {
  return (
    <div>
      <Image
        width={280}
        height={180}
        src={`images/animal_diagnosis/${image}`}
        alt={"バナー画像"}
        loading={"eager"}
        className={"mx-auto"}
      />
    </div>
  );
};

JobTypesPage.Layout = LpLayout;

export async function getStaticProps() {
  return {
    props: {},
  };
}

export default JobTypesPage;
